import * as React from 'react';
import { Button } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import {
  addControlColumn,
  fetchApi,
  List,
  makeResetCache,
  notifyError,
  notifyResponse,
  PageTitle,
  QueryMulti,
  Section,
  useCloneEntity,
} from 'gossamer-front-end';
import { EventBulkUploadView } from 'cb-model';

const DeleteUploadedEventsButton = (props: { value: string | null }) => {
  const dispatch = useDispatch();
  const resetCache = makeResetCache(dispatch);
  const [processing, setProcessing] = React.useState(false);
  const handleClick = async () => {
    setProcessing(true);
    try {
      const payload = {
        transId: props.value,
      };
      const response = await fetchApi('POST', `/main/bulk-event-delete`, payload);
      resetCache(EventBulkUploadView.id, props.value);
      notifyResponse(response);
    } catch (e) {
      notifyError(e, 'An error occurred while deleting the bulk upload');
    }
    setProcessing(false);
  };
  if (props.value === null) {
    return null;
  }
  return (
    <Button size="sm" variant="danger" disabled={processing} onClick={handleClick}>
      Delete
    </Button>
  );
};

export const BulkUploadHistory = (): React.JSX.Element => {
  const LocalEventBulkUploadView = useCloneEntity(EventBulkUploadView, (local) => {
    local.fields.user_id.listColumn = true;
    addControlColumn(
      local,
      'delete_uploaded_events',
      999,
      (row) => (row.curr_event_count > 0 ? row.trans_id : null),
      DeleteUploadedEventsButton,
    );
  });
  return (
    <>
      <PageTitle title="Event Bulk Upload History" subtitle="Previous bulk uploads you have performed" />
      <Section>
        <QueryMulti
          entity={LocalEventBulkUploadView}
          queryOptions={{
            where: { and: [] },
            order: [['back_end_save_at', 'ASC']],
          }}
          render={List}
        />
      </Section>
    </>
  );
};
